import { DependencyList, useEffect } from 'react';

export const useDebounce = (
  callback: () => void,
  delay: number,
  deps: DependencyList = [],
): void => {
  useEffect(() => {
    const handler = setTimeout(callback, delay);

    return () => {
      clearTimeout(handler);
    };
  }, deps);
};
